import React from "react";
import { withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { withFocusable, Loading } from "../../services/visualLibraryService";
import {
  LandingPageStyled,
  LandingContainerStyled,
  LinkStyled,
  ButtonModalStyled,
  LogoStyled,
  PinItemStyled,
  TextStyled,
  PinContainerStyled,
  LineTextStyled,
  LeftBlock,
  RightBlock,
  AlignText,
  StepNumber,
  StepContainer,
  StepText,
  StepTextContainer,
  QRCodeWrapper,
  PinLoginInfoContainer,
  LoginOptionContainer
} from "./styles/Styled";
import { i18n } from "../../services/i18nService";
import { historyMethods } from "../../utils/historyMethods";
import { redirectTo } from "../../services/navigationService";
import { generatePin, loginPin } from "../../services/pinLoginService";
import { routes } from "../../routes";
import { autologin } from "../../services/authenticationService";
import { getLoginRedirectionData } from "../../services/navigationService";
import * as Sentry from "@sentry/browser";
import { getWebPortalURL } from "../../services/tvodService";
import QRCodeReact from "react-qr-code";

import { checkForUmanagedOrNonChangeableMop } from "../../services/billingService";
import FreeLogo from "../../components/FreeLogo";

const ButtonModalFocus = withFocusable(ButtonModalStyled);
const joinFocusPath = "joinVoucherModal_passThru";
const loginFocusPath = "loginVoucherModal_passThru";

class PinLoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pin: "",
      isLoading: true,
      timer: null,
      backDestination: null
    };
    this.onBack = this.onBack.bind(this);
    this.enterHandler = this.enterHandler.bind(this);
  }

  async getPin() {
    const pinResponse = await generatePin();
    this.setState({ pin: pinResponse.pin });
  }

  async componentDidMount() {
    const { location } = this.props;
    this.props.onRef && this.props.onRef(this);
    (async () => {
      await this.getPin().then(async () => {
        this.setState({
          isLoading: false,
          backDestination: location.state && location.state.backDestination
        });
      });

      let { navigationMode, redirectPath } = getLoginRedirectionData.call(this);
      window.pinCheckTimer = setInterval(async () => {
        if (window?.location?.pathname != "/pin") {
          clearInterval(window.pinCheckTimer);
        }
        try {
          const {
            stateActions,
            history,
            applicationState: { voucherData }
          } = this.props;
          const loginPinResponse = await loginPin({ pin: this.state.pin });
          if (loginPinResponse.errorCode === 4009) {
            await this.getPin();
          } else if (loginPinResponse.webToken && loginPinResponse.webToken !== "false") {
            clearInterval(window.pinCheckTimer);
            localStorage.setItem("credentials", loginPinResponse.webToken);
            const data = await autologin();
            stateActions.userLoggedIn(data);
            if (voucherData && voucherData.autoRedeem) {
              let path = await checkForUmanagedOrNonChangeableMop.call(this);
              if (path) {
                redirectTo.call(this, path, null, historyMethods.REPLACE);
              }
            } else {
              redirectPath === "/login" || redirectPath === "/player"
                ? redirectTo.call(this, routes.home, historyMethods.REPLACE)
                : history[navigationMode](redirectPath);
            }
          }
        } catch (error) {
          Sentry.captureException(error);
          console.log(error);
        }
      }, 5000);
    })();
  }

  componentWillUnmount() {
    if (window.pinCheckTimer) {
      clearInterval(window.pinCheckTimer);
    }
  }

  enterHandler(eventAction, path, locationData) {
    // trackEvent(SIGNUP, eventAction);
    redirectTo.call(this, path, locationData, historyMethods.REPLACE);
  }

  onBack() {
    const { applicationState, location, history } = this.props;
    if (applicationState && applicationState.voucherData) {
      redirectTo.call(this, routes.landing, null, historyMethods.REPLACE);
      return true;
    }
    const hasHistoryState = !!(location && location.state);
    if (this.state.backDestination || (hasHistoryState && location.state && location.state.backDestination)) {
      const backDestination = (location.state && location.state.backDestination) || this.state.backDestination;
      const backDestinationPathname = backDestination.pathname || backDestination;
      history.replace(backDestinationPathname);
      return true;
    }
    redirectTo.call(this, routes.home, null, historyMethods.REPLACE);
    return true;
  }

  render() {
    const {
      applicationState: { userLocale: locale },
      location
    } = this.props;

    return (
      <LandingPageStyled>
        {this.state.isLoading && <Loading overlay />}
        <PinLoginInfoContainer>
          <LeftBlock userLocale={locale}>
            <LandingContainerStyled>
              <TextStyled rank="1" text={i18n.get("pages.pinLogin.heading")} size="large" />
              <StepContainer userLocale={locale}>
                <StepNumber>1</StepNumber>
                <StepTextContainer>
                  <StepText rank="3" text={i18n.get("pages.pinLogin.step1")} size="medium" />
                  <br />
                  <LinkStyled rank="2">{"starzplay.com/linktv"}</LinkStyled>
                </StepTextContainer>
              </StepContainer>
              <StepContainer userLocale={locale}>
                <StepNumber>2</StepNumber>
                <StepTextContainer>
                  <StepText rank="3" text={i18n.get("pages.pinLogin.step2")} size="medium" />
                </StepTextContainer>
              </StepContainer>
              <StepContainer userLocale={locale}>
                <StepNumber>3</StepNumber>
                <StepTextContainer>
                  <StepText rank="3" text={i18n.get("pages.pinLogin.step3")} size="medium" />
                  <PinContainerStyled userLocale={locale}>
                    {this.state.pin.split("").map((v, i) => (
                      <PinItemStyled key={`pin-${i}-${v}`}>{v}</PinItemStyled>
                    ))}
                  </PinContainerStyled>
                </StepTextContainer>
              </StepContainer>
            </LandingContainerStyled>
          </LeftBlock>
          <RightBlock userLocale={locale}>
            <AlignText>
              <LogoStyled>
                <FreeLogo />
              </LogoStyled>
            </AlignText>
            <QRCodeWrapper>
              <QRCodeReact value={`${getWebPortalURL()}/linktv?pin=${this.state.pin}`} size={432} />
            </QRCodeWrapper>
          </RightBlock>
        </PinLoginInfoContainer>
        <LoginOptionContainer style={{ display: "flex", flexDirection: "column" }}>
          <LineTextStyled>{i18n.get("pages.pinLogin.or")}</LineTextStyled>

          <ButtonModalFocus
            label={i18n.get("pages.pinLogin.loginButton").toUpperCase()}
            focusPath={joinFocusPath}
            onEnterPress={() =>
              this.enterHandler("login_user_selects_passwordlogin", routes.login, location && location.state)
            }
            size="medium"
            dataSnUp={""}
            dataSnDown={`@${loginFocusPath}`}
            dataSnLeft={""}
            dataSnRight={""}
            type="primary"
            userLocale={locale}
          />
        </LoginOptionContainer>
      </LandingPageStyled>
    );
  }
}

export default withAppState(withSubtheme(PinLoginPage));
